import { web3Actions } from "./web3.action";
import { userActions } from "./user.action";
import { adminActions } from "./admin.action";

export const actions = { ...web3Actions, ...userActions, ...adminActions };
